import React, { createContext, useState, useEffect } from "react";
import { get } from "../api/axios";
import { PLATFORMS } from "../constants/constant";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUserDetails = async () => {
    try {
      const userDetails = await get("/auth/me/");
      const userData = {
        id: userDetails.user_id,
        role: userDetails.role,
        platform: userDetails.platform,
        first_name: userDetails.first_name,
        last_name: userDetails.last_name,
      };

      setUser(userData);
      return userData;
    } catch (error) {
      console.error("Failed to fetch user details", error);
      setUser(null);
      localStorage.removeItem("accessToken");
      throw error;
    }
  };

  const checkUserAccess = (userData) => {
    if (!userData?.platform || !userData?.role) return false;

    return (
      (userData.platform.includes(PLATFORMS.PAYMENT_RECEIPT) &&
        userData.role[PLATFORMS.PAYMENT_RECEIPT]) ||
      (userData.platform.includes(PLATFORMS.EVENT_TRACKER) &&
        userData.role[PLATFORMS.EVENT_TRACKER]) ||
      (userData.platform.includes(PLATFORMS.PASSPORT_TRACKER) &&
        userData.role[PLATFORMS.PASSPORT_TRACKER]) ||
      (userData.platform.includes(PLATFORMS.NIYAZ_APPROVAL) &&
        userData.role[PLATFORMS.NIYAZ_APPROVAL]) ||
      (userData.platform.includes(PLATFORMS.PETTY_CASH) &&
        userData.role[PLATFORMS.PETTY_CASH])
    );
  };

  const hasAccess = (platformName) => {
    return user?.platform?.includes(platformName) && user?.role?.[platformName];
  };

  const hasPageAccess = (platformName, role) => {
    const userRole = user?.role?.[platformName];
    if (!userRole) return false;
    return userRole === role;
  };

  const fetchRole = (location) => {
    let role = "";

    if (location.includes("payment-receipt")) {
      role = user?.role[PLATFORMS.PAYMENT_RECEIPT];
    } else if (location.includes("event-tracker")) {
      role = user?.role[PLATFORMS.EVENT_TRACKER];
    } else if (location.includes("passport-tracker")) {
      role = user?.role[PLATFORMS.PASSPORT_TRACKER];
    } else if (location.includes("niyaaz-approvals")) {
      role = user?.role[PLATFORMS.NIYAZ_APPROVAL];
    } else if (location.includes("petty-cash")) {
      role = user?.role[PLATFORMS.PETTY_CASH];
    }

    const roleMapping = {
      validator: "Validator",
      mushrifa_umoor_dakhliyah: "Mushrifa Umoor Dakhliyah",
      bhabisaab: "Bhabisaab",
      bhensaab: "Bhensaab",
      amil_saheb: "Amil Saheb",
      manager: "Manager",
      requestor: "Requestor",
      office_staff: "Office Staff",
      creator: "Creator",
      joint_secretary: "Joint Secretary",
      mushrif: "Mushrif",
      niyaaz_team: "Niyaaz Team",
      creator: "Creator",
      cashier: "Cashier",
      accounts: "Accounts",
    };

    return roleMapping[role] || role;
  };

  useEffect(() => {
    const initializeUser = async () => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        try {
          await fetchUserDetails();
        } catch (error) {
          console.error("Error initializing user:", error);
        }
      }
      setLoading(false);
    };

    initializeUser();
  }, []);

  return (
    <UserContext.Provider
      value={{
        user,
        loading,
        setUser,
        refreshUser: fetchUserDetails,
        hasAccess,
        hasPageAccess,
        fetchRole,
        checkUserAccess,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
